/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
/********************************Variables********************************/
const dataJson = JSON.parse(document.querySelector(`script[data-product-json]`).innerHTML);
const jsonArray = dataJson.product.variants.filter(item => {
  if(item.available == true){
    return item;
  }
});
const firtsElements = document.querySelectorAll(`input[data-option-position="1"]`);
const secondElements = document.querySelectorAll(`input[data-option-position="2"]`);


function addStyles(arrayElements) {
  arrayElements.forEach(inputStyle => {
    inputStyle.classList.add('solt-out-item');
  });
};


function createArray(variante) {
  let arrayAval = jsonArray.filter(item => {
    if(item.option1 == variante && item.available == true){
      return item;
    }
  });
  return arrayAval;
}

document.addEventListener("DOMContentLoaded", function(){
  if(secondElements.length > 0 ){
    addStyles(secondElements);
    let valueFirst = " ";
    let valueSecond = " ";
    firtsElements.forEach(item => {
      if(item.checked){
        valueFirst = item.value;
      }
    });
    secondElements.forEach(item => {
      if(item.checked){
        valueSecond = item.value;
      }
    });
    secondElements.forEach(element =>{
      jsonArray.forEach(itemFilter => {
        if(itemFilter.option2 == element.value && itemFilter.option1 == valueFirst){
          element.classList.remove('solt-out-item');
        }
      });
    });
  }else{
    addStyles(firtsElements);
    firtsElements.forEach(element =>{
      jsonArray.forEach(itemFilter => {
        if(itemFilter.option1 == element.value){
          element.classList.remove('solt-out-item');
        }
      });
    });
  }
});


document.addEventListener('variant:changed', function(event) {
  const variant = event.detail.variant;
  if(variant != null && secondElements.length > 0 ){
    addStyles(secondElements);
    const varOptionFirst = variant.option1;
    let arrayFilterSecond = createArray(varOptionFirst);
    secondElements.forEach(element =>{
      arrayFilterSecond.forEach(itemFilter => {
        if(itemFilter.option2 == element.value){
          element.classList.remove('solt-out-item');
        }
      });
    });
  }
  else if(secondElements.length > 0){
    addStyles(secondElements);
    firtsElements.forEach(item =>{
      if(item.checked){
        let optionSelected = item.value;
        let arrayFilterSecond = createArray(optionSelected);
        secondElements.forEach(element =>{
          arrayFilterSecond.forEach(itemFilter => {
            if(itemFilter.option2 == element.value){
              element.classList.remove('solt-out-item');
            }
          });
        });
      }
    });
  }
  
});